<p-card *ngIf="specialBenefitsContacts.length > 0" data-auto-id="special-benefits-card">
  <p-accordion value="0">
    <p-accordion-panel class="border-none" value="0">
      <p-accordion-header>
        <div class="flex gap-2">
          <img src="assets/icons/cinch_icon_special_benefits.svg" width="45px" height="45px" alt="Special benefits icon">
          <div class="flex flex-column text-left justify-content-center">
            <p class="text-base text-slate-950 custom-bold m-0">Special Benefits</p>
          </div>
        </div>
      </p-accordion-header>
      <p-accordion-content>
        <p class="mt-0 text-base font-normal line-height-3">To open the request, please call and make
          sure that you provide your plan group number.</p>
        <div *ngFor="let benefit of specialBenefitsContacts; let i = index; trackBy: trackByIndex">
          <p class="custom-bold">{{benefit.itemDescription}}</p>
          <p>Phone number: <span [innerHTML]="benefit.phoneNumber | phone:true" appGaButtonClick
              [buttonLocation]="pageLocation" [buttonName]="specialBenefitsButtonName"></span>
          </p>
          <p>Group #: {{benefit.groupNumber || 'N/A'}}</p>
          <p *ngIf="benefit.url"><label>Link: </label>&nbsp;<a href="{{benefit.url}}" target="_blank"
              rel="noopener noreferrer">cinchelectronics.com</a></p>
        </div>
      </p-accordion-content>
    </p-accordion-panel>
  </p-accordion>
</p-card>